"use strict";
// Craft Room Database Types - Shared between backend and frontend
// These types represent the actual DynamoDB records
// Created: 2026-07-20
// Updated: 2026-09-07
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialType = void 0;
var MaterialType;
(function (MaterialType) {
    MaterialType["PUBLIC"] = "public";
    MaterialType["PERSONAL"] = "personal";
    MaterialType["NONSTANDARD"] = "nonstandard";
})(MaterialType || (exports.MaterialType = MaterialType = {}));
